export default __webpack_public_path__ + "static/media/addressproof.5f30db55.png";